import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);

    _defineProperty(this, "estoreLocation", null);

    _defineProperty(this, "siteLocation", null);

    _defineProperty(this, "nameCookiesInternal", []);
  }

  _createClass(_default, [{
    key: "nameCookies",
    get: function get() {
      return this.nameCookiesInternal;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      if (this.cartUrlInternal) {
        return this.cartUrlInternal;
      }

      return "".concat(this.estoreLocation, "/cart");
    },
    set: function set(value) {
      this.cartUrlInternal = value;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      if (this.loginUrlInternal) {
        return this.loginUrlInternal;
      }

      return "".concat(this.siteLocation, "/your-accounts/");
    },
    set: function set(value) {
      this.loginUrlInternal = value;
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      if (this.accountOverviewUrlInternal) {
        return this.accountOverviewUrlInternal;
      }

      return "".concat(this.siteLocation, "/your-accounts/");
    },
    set: function set(value) {
      this.accountOverviewUrlInternal = value;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      if (this.logoutUrlInternal) {
        return this.logoutUrlInternal;
      }

      return "".concat(this.siteLocation, "/your-accounts/?signout=true");
    },
    set: function set(value) {
      this.logoutUrlInternal = value;
    }
  }]);

  return _default;
}();

export { _default as default };